import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ThemesWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-themes.sass');

export class ThemesWidget extends WidgetBase {
    public static _name: string = 'Themes';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-themes';
    public static icon: string = 'th';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-themes'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ThemesWidget);
